<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-upload"></i> 出库记录</span>
      </div>
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="低值易耗" name="consumables">
          <ConsumableMaterialTab />
        </el-tab-pane>
        <el-tab-pane label="食材物资" name="food">
          <FoodMaterialTab />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>

import ConsumableMaterialTab from "./consumableTab.vue";
import FoodMaterialTab from "./foodTab.vue";

export default {
  name: "OutStockRecord",
  components: {
    ConsumableMaterialTab,
    FoodMaterialTab,
  },
  data() {
    return {
      activeTab: "consumables", // 默认激活“固定物资”Tab
    };
  },
  methods: {
    handleTabChange(val) {
      //  todo
      // this.activeTab = this.$route.query.activeTab;
    },
  },
};
</script>

<style scoped>
.app-container {
  
}
.el-card {
  margin-bottom: 20px;
}
</style>
